jQuery(function ($) {
  if (!$(".technologies").length) return;

  $(".technologies").each(function () {
    var $root = $(this);
    var $tabs = $root.find("[data-tab]");
    var $panels = $root.find("[data-panel]");

    if (!$tabs.length || !$panels.length) return;

    function activate(id) {
      $tabs.each(function () {
        var $t = $(this);
        var active = String($t.data("tab")) === String(id);

        $t.toggleClass("tab-active", active).attr(
          "aria-selected",
          active ? "true" : "false",
        );
      });

      $panels.each(function () {
        var $p = $(this);
        var active = String($p.data("panel")) === String(id);

        $p.toggleClass("is-active", active);

        if (active) {
          $p.removeAttr("hidden");
        } else {
          $p.attr("hidden", "hidden");
        }
      });
    }

    activate($tabs.first().data("tab"));

    $tabs.on("click", function (e) {
      e.preventDefault();
      activate($(this).data("tab"));
    });
  });
});

jQuery(function ($) {
  if (!$(".faq [data-accordion]").length) return;

  $(".faq [data-accordion]").each(function () {
    var $accordion = $(this);

    function closeItem($item) {
      var $panel = $item.find("[data-acc-panel]");
      $item.removeClass("is-open");
      $item.find("[data-acc-btn]").attr("aria-expanded", "false");

      $panel.stop(true, true).slideUp(250, function () {
        $panel.attr("hidden", "hidden");
      });
    }

    function openItem($item) {
      var $panel = $item.find("[data-acc-panel]");
      $item.addClass("is-open");
      $item.find("[data-acc-btn]").attr("aria-expanded", "true");

      $panel.stop(true, true).removeAttr("hidden").hide().slideDown(250);
    }

    $accordion.find("[data-acc-panel]").each(function () {
      var $p = $(this);
      if ($p.is(":visible")) $p.hide();
    });

    $accordion.on("click", "[data-acc-btn]", function (e) {
      e.preventDefault();

      var $item = $(this).closest("[data-acc-item]");
      var isOpen = $item.hasClass("is-open");

      $accordion.find("[data-acc-item].is-open").each(function () {
        closeItem($(this));
      });

      if (!isOpen) openItem($item);
    });
  });
});

jQuery(function ($) {

  if (!$('.dynamic-gallery').length) return;

  function initGallerySlider($scope) {
    $scope.find('.js-dynamic-gallery-slider').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) return;
      if ($slider.find('.dynamic-gallery__slide').length <= 1) return;

      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false
      });
    });
  }

  $('.dynamic-gallery').each(function () {

    var $block = $(this);
    var $tabs = $block.find('[data-tab]');
    var $panels = $block.find('[data-tab-panel]');

    if (!$tabs.length || !$panels.length) return;

    function activate(index) {
      $tabs.removeClass('tab-card-active');
      $panels.hide();

      var $activeTab = $block.find('[data-tab="' + index + '"]');
      var $activePanel = $block.find('[data-tab-panel="' + index + '"]');

      $activeTab.addClass('tab-card-active');
      $activePanel.show();

      initGallerySlider($activePanel);

      $activePanel.find('.js-dynamic-gallery-slider.slick-initialized').slick('setPosition');
    }

    $tabs.on('click', function (e) {
      e.preventDefault();
      activate($(this).data('tab'));
    });

    activate(0);

  });

});

jQuery(document).ready(function ($) {
    $('[data-tabs]').each(function () {
        var $tabsWrapper = $(this);
        var $section = $tabsWrapper.closest('.site-header-mm__wrapper__content__technologies__upper');
        $tabsWrapper.find('[data-tab]').on('click', function () {
            var tabKey = $(this).data('tab');
            $tabsWrapper.find('[data-tab]')
                .removeClass('tab-active')
                .attr('aria-selected', 'false');
            $(this)
                .addClass('tab-active')
                .attr('aria-selected', 'true');
            $section.find('[data-panel]')
                .removeClass('is-active')
                .hide();
            $section.find('[data-panel="' + tabKey + '"]')
                .addClass('is-active')
                .fadeIn(200);
        });
    });
});

(function () {
  const featuredEl = document.getElementById("blogFeatured");
  const gridEl = document.getElementById("blogGrid");
  const paginationEl = document.getElementById("blogPagination");
  const tabs = document.querySelectorAll("[data-tab-btn]");
  const searchInput = document.getElementById("blogSearch");

  if (!featuredEl || !gridEl || !paginationEl || !tabs.length) return;

  const urlParams = new URLSearchParams(window.location.search);
  let currentPage = parseInt(urlParams.get("pg"), 10) || 1;
  let activeCat = "0";
  let searchVal = "";
  let firstLoad = true;

  function setActiveTab(catId) {
    tabs.forEach((btn) => {
      btn.classList.toggle("tab-active", btn.getAttribute("data-cat") === String(catId));
    });
  }

  function updateURL() {
    const params = new URLSearchParams(window.location.search);
    if (currentPage <= 1) {
      params.delete("pg");
    } else {
      params.set("pg", currentPage);
    }
    const newUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
    window.history.pushState(
      { page: currentPage, cat: activeCat, search: searchVal },
      "",
      newUrl
    );
  }

  function loadPosts(pushUrl = true) {
    const fd = new FormData();
    fd.append("action", "zendev_blog_filter");
    fd.append("cat_id", activeCat);
    fd.append("search", searchVal);
    fd.append("page", currentPage);

    fetch(window.ajaxurl || "/wp-admin/admin-ajax.php", {
      method: "POST",
      body: fd
    })
      .then((r) => r.json())
      .then((res) => {
        if (!res || !res.success) return;

        featuredEl.innerHTML = res.data.featured || "";
        gridEl.innerHTML = res.data.grid || "";
        paginationEl.innerHTML = res.data.pagination || "";
        featuredEl.style.visibility = "";
        gridEl.style.visibility = "";
        paginationEl.style.visibility = "";

        if (pushUrl) {
          updateURL();
        }

        if (!firstLoad) {
          const wrap = document.querySelector(".blog-body__wrapper__bottom");
          if (wrap) {
            wrap.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        firstLoad = false;
      })
      .catch((err) => {
        console.error("Blog AJAX error:", err);
      });
  }

  tabs.forEach((btn) => {
    btn.addEventListener("click", () => {
      activeCat = btn.getAttribute("data-cat");
      currentPage = 1;
      setActiveTab(activeCat);
      loadPosts(true);
    });
  });

  let searchTimer;
  if (searchInput) {
    searchInput.addEventListener("input", () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        searchVal = searchInput.value.trim();
        currentPage = 1;
        loadPosts(true);
      }, 250);
    });
  }

  paginationEl.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-page]");
    if (!btn || btn.disabled) return;

    const page = parseInt(btn.getAttribute("data-page"), 10);
    if (!page || page === currentPage) return;

    currentPage = page;
    loadPosts(true);
  });

  window.addEventListener("popstate", () => {
    const params = new URLSearchParams(window.location.search);
    currentPage = parseInt(params.get("pg"), 10) || 1;
    loadPosts(false);
  });

  setActiveTab(activeCat);

  if (currentPage > 1) {
    loadPosts(false);
  }
})();

jQuery(document).ready(function ($) {

  var map = {
    'mm-hww': '.megamenu-howwework',
    'mm-s': '.megamenu-services',
    'mm-r': '.megamenu-resources'
  };

  var openTimer = null;
  var closeTimer = null;
  var activeKey = null;

  $(document).on('click', '.menu-items li.mm-hww > a, .menu-items li.mm-s > a, .menu-items li.mm-r > a', function (e) {
    e.preventDefault();
  });

  function closeAll() {
    $('.site-header-mm').removeClass('is-open');
    $('.menu-items li.mm-hww, .menu-items li.mm-s, .menu-items li.mm-r').removeClass('is-mm-active');
    activeKey = null;
  }

  function detectKey($li) {
    if ($li.hasClass('mm-hww')) return 'mm-hww';
    if ($li.hasClass('mm-s')) return 'mm-s';
    if ($li.hasClass('mm-r')) return 'mm-r';
    return null;
  }

  function openMenu(key, $li) {
    $('.site-header-mm').removeClass('is-open');
    $('.menu-items li.mm-hww, .menu-items li.mm-s, .menu-items li.mm-r').removeClass('is-mm-active');

    $(map[key]).addClass('is-open');
    $li.addClass('is-mm-active');

    activeKey = key;
  }

  $(document).on('mouseenter', '.menu-items li.mm-hww, .menu-items li.mm-s, .menu-items li.mm-r', function () {
    var $li = $(this);
    var key = detectKey($li);
    if (!key) return;

    clearTimeout(closeTimer);
    clearTimeout(openTimer);

    openTimer = setTimeout(function () {
      openMenu(key, $li);
    }, 30);
  });

  $(document).on('mouseleave', '.menu-items li.mm-hww, .menu-items li.mm-s, .menu-items li.mm-r', function () {
    clearTimeout(openTimer);

    closeTimer = setTimeout(function () {
      if (
        !$('.site-header-mm:hover').length &&
        !$('.menu-items li.mm-hww:hover, .menu-items li.mm-s:hover, .menu-items li.mm-r:hover').length
      ) {
        closeAll();
      }
    }, 220);
  });

  $(document).on('mouseenter', '.site-header-mm__wrapper', function () {
    clearTimeout(closeTimer);
  });

  $(document).on('mouseleave', '.site-header-mm__wrapper', function () {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      if (!$('.menu-items li.mm-hww:hover, .menu-items li.mm-s:hover, .menu-items li.mm-r:hover').length) {
        closeAll();
      }
    }, 220);
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  var $header = $('.site-header');
  var $mm = $('.site-header-mm');

  function syncScrollClasses() {
    var isMoving = $(window).scrollTop() > 1;
    $header.toggleClass('header-is-moving', isMoving);
    $mm.toggleClass('megamenu-fp', isMoving);
  }

  syncScrollClasses();

  $(window).on('scroll', syncScrollClasses);

});

jQuery(document).ready(function ($) {

  $('.wpcf7 form').each(function () {

    var $form = $(this);
    var $sel  = $form.find('select[name="reason"]');

    if (!$sel.length) return;

    // Matched by option position (not value/text) so this keeps working
    // across translated forms, where values like "Project"/"Other" are
    // translated per language but the option order stays the same.
    var order = ['condition_project', 'condition_media', 'condition_other'];

    function showOne() {

      $form.find('[data-class="wpcf7cf_group"]').css('display', 'none');

      var $options = $sel.find('option').not('[value=""]');
      var $selected = $sel.find('option').eq($sel.prop('selectedIndex'));
      var index = $options.index($selected);

      var id = order[index];
      if (!id) return;

      var $target = $form.find('[data-id="' + id + '"]');
      if ($target.length) {
        $target.css('display', 'block');
      }
    }

    showOne();

    $sel.on('change', showOne);

    document.addEventListener('wpcf7submit', function (e) {
      if (e.target === $form[0]) showOne();
    });

    document.addEventListener('wpcf7invalid', function (e) {
      if (e.target === $form[0]) showOne();
    });

  });

});

jQuery(function ($) {

  var $formWrap = $('.contact-form__wrapper__form');

  if ($formWrap.length) {
    $formWrap.addClass('is-ready');
  }

});

jQuery(function ($) {

  var activeItem = null;

  function isTabletWidth() {
    var w = window.innerWidth;
    return w <= 1200 && w >= 768;
  }

  $('.site-header__wrapper__nav').on('click', 'li.mm > a', function (e) {

    if (!isTabletWidth()) return;

    var $li = $(this).parent();

    if (activeItem !== $li[0]) {
      e.preventDefault();

      $('.site-header__wrapper__nav li.mm').removeClass('is-open');

      $li.addClass('is-open');
      activeItem = $li[0];

      return;
    }

    activeItem = null;
  });

  $(window).on('resize', function () {
    activeItem = null;
    $('.site-header__wrapper__nav li.mm').removeClass('is-open');
  });

});

jQuery(function ($) {

  $('.site-header__wrapper__cta-switch__bars').on('click', function () {

    var $bars = $(this);
    var isActive = $bars.toggleClass('bars-active').hasClass('bars-active');

    $('html, body').toggleClass('overflow-hidden', isActive);
    $('.site-header-mobilemenu').toggleClass('mobilemenu-is-active', isActive);

  });

});

jQuery(function ($) {

  $('.site-header-mobilemenu').on(
    'click',
    '.mobile-menu-item.menu-item-has-children > .mobile-menu-item__link',
    function (e) {

      e.preventDefault();

      var $parent = $(this).closest('.mobile-menu-item.menu-item-has-children');

      if ($parent.hasClass('submenu-active')) {
        $parent.removeClass('submenu-active');
      } else {
        $('.mobile-menu-item.menu-item-has-children.submenu-active')
          .not($parent)
          .removeClass('submenu-active');

        $parent.addClass('submenu-active');
      }

    }
  );

});

jQuery(function ($) {

  function handleMobileMenuFP() {

    if (window.innerWidth <= 1200) {

      if ($(window).scrollTop() > 1) {
        $('.site-header-mobilemenu').addClass('mobile-menu-fp');
      } else {
        $('.site-header-mobilemenu').removeClass('mobile-menu-fp');
      }

    } else {
      $('.site-header-mobilemenu').removeClass('mobile-menu-fp');
    }

  }

  $(window).on('scroll', handleMobileMenuFP);

  $(window).on('resize', handleMobileMenuFP);

  handleMobileMenuFP();

});

jQuery(function () {

  var isMobile = window.innerWidth <= 767;
  var rootMarginBottom = isMobile ? '-1px' : '-100px';

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains('cards')) {
          var btn = entry.target.querySelector('.cards__wrapper__bottom__btn');
          var isProjects = !!entry.target.querySelector('.cards__wrapper__bottom__projects-wrapper');
          var isTestimonials = !!entry.target.querySelector('.cards__wrapper__bottom__testimonials');
          var isBlog = !!entry.target.querySelector('.cards__wrapper__bottom__blog');
          var isHighlightedCards = !!entry.target.querySelector('.cards__wrapper__bottom__h-cards');

          if (isProjects) {
            var singles = entry.target.querySelectorAll('.cards__wrapper__bottom__projects__single');
            var baseDelay = 0.6;
            singles.forEach(function (single, i) {
              single.style.transitionDelay = (baseDelay + i * 0.2).toFixed(1) + 's';
            });
            if (btn) {
              btn.style.transitionDelay = (baseDelay + singles.length * 0.2).toFixed(1) + 's';
            }
          } else if (isTestimonials) {
            // no per-card delay — wrapper animates as one
          } else if (isBlog) {
            var baseDelay = 0.6;
            var featured = entry.target.querySelector('.cards__wrapper__bottom__blog__featured');
            if (featured) {
              featured.style.transitionDelay = baseDelay.toFixed(1) + 's';
            }
            // no per-card delay — __others wrapper animates as one
          } else if (isHighlightedCards) {
            var singles = entry.target.querySelectorAll('.cards__wrapper__bottom__h-cards__single');
            var baseDelay = 0.6;
            singles.forEach(function (single, i) {
              single.style.transitionDelay = (baseDelay + i * 0.2).toFixed(1) + 's';
            });
          } else {
            var cardItems = entry.target.querySelectorAll('.cards__wrapper__bottom__cards > *');
            var baseDelay = 0.6;
            cardItems.forEach(function (card, i) {
              card.style.transitionDelay = (baseDelay + i * 0.2).toFixed(1) + 's';
            });
            if (btn) {
              btn.style.transitionDelay = (baseDelay + cardItems.length * 0.2).toFixed(1) + 's';
            }
          }
        }
        if (entry.target.classList.contains('single-quote')) {
          entry.target.querySelectorAll('.single-quote__wrapper__quote').forEach(function (quote, i) {
            quote.style.transitionDelay = (i * 0.2).toFixed(1) + 's';
          });
        }
        if (entry.target.classList.contains('faq')) {
          entry.target.querySelectorAll('.faq__wrapper__faqs__single').forEach(function (single, i) {
            single.style.transitionDelay = (0.6 + i * 0.2).toFixed(1) + 's';
          });
        }
        if (entry.target.classList.contains('team')) {
          var hasImage = !!entry.target.querySelector('.team__wrapper__image');
          var membersBase = hasImage ? 0.8 : 0.6;
          entry.target.querySelectorAll('.team__wrapper__members__single').forEach(function (single, i) {
            single.style.transitionDelay = (membersBase + i * 0.2).toFixed(1) + 's';
          });
        }
        if (entry.target.classList.contains('text-image')) {
          var additionalSingles = entry.target.querySelectorAll('.text-image__main__additional__cards__single');
          additionalSingles.forEach(function (single, i) {
            single.style.transitionDelay = (1.3 + i * 0.2).toFixed(1) + 's';
          });
        }
        if (entry.target.classList.contains('post-body-related')) {
          entry.target.querySelectorAll('.post-body-related__wrapper .hover-element').forEach(function (el, i) {
            el.style.transitionDelay = (i * 0.2).toFixed(1) + 's';
          });
        }
        if (entry.target.classList.contains('contact-form')) {
          entry.target.querySelectorAll('.contact-form__wrapper__contact-cards__single').forEach(function (single, i) {
            single.style.transitionDelay = (0.2 + i * 0.2).toFixed(1) + 's';
          });
        }
        if (entry.target.classList.contains('positions')) {
          var positionSingles = entry.target.querySelectorAll('.positions__wrapper__bottom__positions > *');
          positionSingles.forEach(function (single, i) {
            single.style.transitionDelay = (i * 0.2).toFixed(1) + 's';
          });
          var cta = entry.target.querySelector('.cards__wrapper__bottom__btn, .positions__wrapper__bottom__load-more');
          if (cta) {
            cta.style.transitionDelay = (positionSingles.length * 0.2).toFixed(1) + 's';
          }
        }
        entry.target.classList.add('is-animated');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px ' + rootMarginBottom + ' 0px'
  });

  document.querySelectorAll('.text-image, .awards, .cards, .cta-banner, .technologies, .team, .faq, .cta-text, .text, .single-quote, .blog-body, .positions, .dynamic-gallery, .contact-form, .post-body, .post-body-related, .cta-form').forEach(function (el) {
    observer.observe(el);
  });

});

jQuery(function ($) {

  var $sliders = $('.js-cards-slider-mobile');

  if (!$sliders.length) return;

  function initCardsMobileSlider() {
    $sliders.each(function () {
      var $slider = $(this);

      if ($(window).width() < 767) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            centerMode: true,
            centerPadding: '24px',
            mobileFirst: true,
            adaptiveHeight: true
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    });
  }

  initCardsMobileSlider();
  $(window).on('resize', initCardsMobileSlider);

});

(function () {
  const arrowSVG = (dir) => `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      ${dir === 'left' ? '<polyline points="15 18 9 12 15 6"/>' : '<polyline points="9 18 15 12 9 6"/>'}
    </svg>`;

  function initTabsArrows(tabs) {
    if (tabs.scrollWidth <= tabs.clientWidth) return;

    const wrapper = document.createElement('div');
    wrapper.className = tabs.className.replace('technologies__wrapper__tech__tabs', 'technologies__wrapper__tech__tabs-wrapper');
    wrapper.style.cssText = 'display:flex;align-items:center;gap:8px;';

    tabs.parentNode.insertBefore(wrapper, tabs);
    wrapper.appendChild(tabs);

    tabs.style.flex = '1';
    tabs.style.minWidth = '0';

    const btnLeft = document.createElement('button');
    btnLeft.type = 'button';
    btnLeft.className = 'tabs-scroll-arrow tabs-scroll-arrow--left is-hidden';
    btnLeft.setAttribute('aria-label', 'Scroll left');
    btnLeft.innerHTML = arrowSVG('left');

    const btnRight = document.createElement('button');
    btnRight.type = 'button';
    btnRight.className = 'tabs-scroll-arrow tabs-scroll-arrow--right';
    btnRight.setAttribute('aria-label', 'Scroll right');
    btnRight.innerHTML = arrowSVG('right');

    wrapper.insertBefore(btnLeft, tabs);
    wrapper.appendChild(btnRight);

    const scrollAmount = 120;

    function updateArrows() {
      btnLeft.classList.toggle('is-hidden', tabs.scrollLeft <= 0);
      btnRight.classList.toggle('is-hidden', tabs.scrollLeft + tabs.clientWidth >= tabs.scrollWidth - 1);
    }

    btnLeft.addEventListener('click', () => {
      tabs.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    btnRight.addEventListener('click', () => {
      tabs.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    tabs.addEventListener('scroll', updateArrows);
    updateArrows();
  }

  document.querySelectorAll('.technologies__wrapper__tech__tabs[data-tabs]').forEach(initTabsArrows);
})();